// Browser file-download helpers, shared by the results export + CSV templates.

/**
 * Trigger a browser download for an in-memory Blob. Centralizes the
 * create-anchor -> click -> revoke dance (previously inlined in
 * ImportQuestionsModal).
 */
export function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/**
 * Pull the download filename out of a Content-Disposition header. Prefers the
 * RFC 5987 `filename*=UTF-8''…` form (percent-decoded), then falls back to the
 * quoted ASCII `filename="…"`. Returns null when neither is present.
 */
export function parseContentDispositionFilename(
  header: string | null,
): string | null {
  if (!header) return null;
  const star = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (star) {
    try {
      return decodeURIComponent(star[1]);
    } catch {
      // Malformed percent-encoding — fall through to the ASCII form.
    }
  }
  const quoted = /filename="?([^";]+)"?/i.exec(header);
  return quoted ? quoted[1] : null;
}
